import React, { useState, useEffect } from 'react';
import { Form, Button, Container, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import '../../styles/login.css';

const LoginPage = () => {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Redirecionar se já estiver logado
  useEffect(() => {
    if (user) {
      navigate('/hub');
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !password) {
      setError('Email e senha são obrigatórios');
      return;
    }
    
    setError(null);
    setLoading(true);
    
    try {
      await login(email, password);
      navigate('/hub');
    } catch (error) {
      console.error('Erro de login:', error);
      
      if (error.message === 'USER_INACTIVE') {
        setError('Sua conta está desativada. Entre em contato com o administrador.');
      } else if (error.message?.includes('Invalid login credentials')) {
        setError('Email ou senha incorretos. Verifique suas credenciais.');
      } else {
        setError('Erro ao fazer login. Tente novamente.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <Container fluid className="login-container">
        <div className="login-left-panel">
          <div className="logo-container">
            <div className="logo-circle">
              <span className="logo-text">MM</span>
            </div>
            <div className="logo-brand">
              <div className="brand-name">EVENTOS</div>
              <div className="brand-subtitle">HEALTH DIVISION</div>
            </div>
          </div>
        </div>
        
        <div className="login-right-panel">
          <div className="login-form-container">
            <div className="welcome-section">
              <h1 className="welcome-title">Bem-vindo</h1>
              <p className="welcome-subtitle">MM Eventos</p>
            </div>
            
            {error && (
              <Alert variant="danger" className="login-alert">
                {error}
              </Alert>
            )}
            
            <Form onSubmit={handleSubmit} className="login-form">
              <Form.Group className="mb-3">
                <Form.Control 
                  type="email" 
                  placeholder="Digite seu email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={loading}
                  required
                  className="login-input"
                />
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Control 
                  type="password" 
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={loading}
                  required
                  className="login-input"
                />
              </Form.Group>

              <Button 
                type="submit" 
                className="login-button"
                disabled={loading}
              >
                {loading ? 'ENTRANDO...' : 'ENTRAR'}
              </Button>
            </Form>
            
            <div className="login-footer">
              <small>
                © {new Date().getFullYear()} MM Eventos® Health Division
              </small>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default LoginPage;